import src from "IMAGE";
export default { src, width: 356, height: 77, blurWidth: 0, blurHeight: 0};
